// extracted by mini-css-extract-plugin
export default {"wrapper":"p1-z","play":"q1-z"};